<template>
    <div class="ContentBox">
      <!-- :issearch="isSearch" -->
        <div class="commonBox TopsBlack"> <Tops :ishome="false"  @isSearch="toSearch"/></div>
        <el-carousel class="bannerBox"  trigger="click" indicator-position="outside" >
            <el-carousel-item v-for="item in 1" :key="item">
             <img src="@/assets/banner-2.png" />
            </el-carousel-item>
        </el-carousel>
        <!--  -->
        <PathBox  @CurrIds="GetCurrIds" />
        <!--  -->
        <div class="ListMenuBox">
            <div class="MenuList" v-if="MenuArr.length">
               <span v-for="(v,i) in MenuArr " :class="i==CurrAct?'act':''" :key="i" @click="LookNavList(i,v['ID'],v['Type'])">{{v['Name']}}</span>
            </div>
            <template v-if="Arrs.total>0">
                <template v-if="CurrTypes=='3'">
                  <ProTips v-for="(v,i) in Arrs['row']" :Item="v" :key="i"  />
                </template>
                <template  v-else>
                  <ListItem v-for="(v,i) in Arrs['row']" :Item="v" :key="i" @LookInfo="LookInfo"/>
                </template>
            </template>
            <template v-else>
              <Error />
            </template>
            <el-pagination
                v-if="Arrs.total>0"
                style="margin-top:50px;clear:both;"
                :current-page.sync="CurrPage"
                @click="handleCurrentChange"
                :page-size="15"
                layout="total, prev, pager, next"
                :total="Arrs.total">
            </el-pagination>
        </div>
        <Footer />
    </div>
</template>
<script>
import Tops from "@/components/PubBox/hearTop.vue";
import Footer from "@/components/PubBox/footer.vue";
import PathBox from "@/components/PubBox/PathBox.vue";
import ProTips from "@/components/ListBox/ProTips.vue";
import ListItem from "@/components/ListBox/ListItem.vue";
import Error from '@/components/PubBox/Error.vue';
import {GetNewsInfoByCid,GetCNavColumnsByCid,GetFilesInfoByCid} from '@/requestPub/api';
export default {
    components:{
        Tops,Footer,PathBox,ProTips,ListItem,Error
    },
    data() {
      return {
        CurrPage: 1,
        MenuAct:'',
        CurrTypes:'',
        CurrAct:0,
        NavIndex:'',
        tableData:[{},{},{}],
        Arrs:{},
        MenuArr:new Array(),
        CurrID :'',
        isSearchVal:false
      }
    },
    watch:{
      CurrPage(){
          this.GetInfo();
      }
    },
    methods:{  
      GetCurrIds(n){
        this.CurrAct=0;
        this.CurrID= n.ids;
        this.CurrTypes = n.types;
        this.MenuArr = new Array();
        this.isSearchVal= this.$route.query.keys || '';
        this.GetInfoC();
      },
      toSearch(val){
          this.CurrPage=1;
          this.MenuArr = new Array();
          this.isSearchVal= val;
          this.GetInfo()
      },
      GetInfoC(){
        GetCNavColumnsByCid({Cid:this.CurrID}).then((e)=>{
          this.MenuArr = e.Data;
          if(e.Data.length>0){
            this.CurrTypes = this.MenuArr[0].Type
          }
          if( this.CurrTypes  == 4 || this.CurrTypes  == 3){
            GetFilesInfoByCid({Cid:this.MenuArr.length>0?this.MenuArr[0].ID:this.CurrID,PageSize:15,PageIndex:this.CurrPage,SearchWord:this.isSearchVal}).then((e)=>{
              this.Arrs = e.Data;
            })
          }else{
            GetNewsInfoByCid({Cid:this.MenuArr.length>0?this.MenuArr[0].ID:this.CurrID,PageSize:15,PageIndex:this.CurrPage,SearchWord:this.isSearchVal}).then((e)=>{
              this.Arrs = e.Data;
            })
          }    
        })
      },
      GetInfo(){   
        // console.log(this.CurrTypes)
          if( this.CurrTypes  == 4 || this.CurrTypes  == 3){
            GetFilesInfoByCid({Cid:this.CurrID,PageSize:15,PageIndex:this.CurrPage,SearchWord:this.isSearchVal}).then((e)=>{
            this.Arrs = e.Data;
            })
          }else{
            GetNewsInfoByCid({Cid:this.CurrID,PageSize:15,PageIndex:this.CurrPage,SearchWord:this.isSearchVal}).then((e)=>{
            this.Arrs = e.Data;
          })
        }
      },
      GetNavClick(e){
        this.CurrPage=1;
        this.NavIndex = e;
      }, 
      LookInfo(n){
        console.log(n)
        if(this.CurrTypes == 2 ){
          if(n.url && n.url!='null'){
            window.open(n.url)
          }else{
            this.$router.push('/ListArtInfo?ids='+n.ids);
          }
        }
        if(this.CurrTypes == 4){
          window.open(n.url)
        }
      },
      LookNavList(n,ids,types){
        this.Arrs = new Object();
        this.CurrPage=1;
        this.CurrAct=n;
        this.CurrID= ids;
        this.CurrTypes= types;
        this.GetInfo()
      },
      ChangeNavMenu(n){
        this.MenuAct= n;
      },
      handleCurrentChange(val) {
        this.GetInfo();
      }
    }
}
</script>
<style lang="scss">
  .bannerBox {
    height: 400px;
    .el-carousel__container {
      height: 100%;
    }
    .el-carousel__indicators--outside {
      position: absolute;
      bottom: 100px;
    }
    .el-carousel__item {
      img,
      .el-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
 // ListMenuBox
  .ListMenuBox{
      width:1260px;
      margin: 60px auto 0;
      text-align: inherit;
      .MenuList{
        display: inline-flex;
        width:100%;
        margin-bottom: 20px;
        span{
          background:  #F5F5F5;;
          width:calc(100% / 3);
          padding: 5px 20px;
          // line-height: 30px;
          font-size: 15px;
          &:hover{
            cursor: pointer;
            //  color:#fff;
             transform: scale(1.03);
            // background: linear-gradient(90deg, #4160CE, #4160CE);
            transition: all .5s;
          }
        }
        span:nth-child(2){
          margin: 0 20px;
        }
        .act{
          color:#fff;
          background: linear-gradient(90deg, #4160CE, #4160CE);
        }
      }

  }
</style>